import { SetVolumeEvent } from "./incomingEvents"
import { setAudioVolume } from "../../../ucs"
import { convertAmnVolumeToUcsVolume } from "./volumeConversion"

export const handleSetVolumeEvent = (event: SetVolumeEvent) => {
  const {
    payload: { volume },
  } = event
  const ucsVolume = convertAmnVolumeToUcsVolume(volume)
  setAudioVolume(ucsVolume)
}
